import type {OttoNexus, QueuableFunction} from "@otto-ec/global-resources/nexus";
import {apps} from "../index";
import type {OptOutAllMessages} from "./optOutAllMessages";
import type {OptOutGeneralVendorDto} from "./optOutGeneralVendorDto";
import type {OpenPreferenceCenterDto} from "./openPreferenceCenterDto";

export type CookieBanner = {
    resurface: QueuableFunction<Resurface>;
    openPreferenceCenter: QueuableFunction<OpenPreferenceCenter>
    optOutAll: QueuableFunction<OptOutAll>;
    optOutGeneralVendor: QueuableFunction<OptOutGeneralVendor>;
}

export type Resurface =
/**
 *
 */
    () => void;

export type OpenPreferenceCenter =
/**
 *
 */
    (data: OpenPreferenceCenterDto) => void;

export type OptOutAll =
/**
 *
 */
    (data: OptOutAllMessages) => void;

export type OptOutGeneralVendor =
/**
 *
 */
    (data: OptOutGeneralVendorDto) => void;

/**
 *
 */
export const cookieBanner: OttoNexus["apps"]["cookieBanner"] = apps.cookieBanner;

export const {
    /**
 *
 */
    resurface,
    /**
 *
 */
    openPreferenceCenter,
    /**
 *
 */
    optOutAll,
    /**
 *
 */
    optOutGeneralVendor
} = cookieBanner;